import axios from '@/utils/request';

const baseOriginURL = process.env.VUE_APP_API_PREFIX_1 + '/product';
const baseOriginURL2 = process.env.VUE_APP_API_PREFIX_2;
const baseOriginURL3 = process.env.VUE_APP_API_PREFIX_1 + '/device';

// 产品类别
const ProductType = data => {
  return axios.post(baseOriginURL + '/GetProduceGroupList', data);
};

// 新增产品类别
const AddProductType = data => {
  return axios.post(baseOriginURL + '/AddProduceGroup', data);
};

// 编辑产品类别
const EditProductType = data => {
  return axios.put(baseOriginURL + '/UpdateProduceGroup', data);
};

// 删除产品类别
const DeleteProductType = data => {
  return axios.put(baseOriginURL + '/DelProduceGroup', data);
};

// 产品
const Product = data => {
  return axios.post(baseOriginURL + '/GetProduceList', data);
};

// 产品信息
const ProductInfo = data => {
  return axios.post(baseOriginURL + '/GetProduceInfo', data);
};

// 新增产品
const AddProduct = data => {
  return axios.post(baseOriginURL + '/AddProduce', data);
};

// 编辑产品
const EditProduct = data => {
  return axios.put(baseOriginURL + '/UpdateProduce', data);
};

// 删除产品
const DeleteProduct = data => {
  return axios.put(baseOriginURL + '/DelProduce', data);
};

// 同步信息产品
const SyncInfoProduct = data => {
  return axios.put(baseOriginURL + '/SyncProduct', data);
};

// 控制器
const Controler = data => {
  return axios.post(baseOriginURL + '/GetProduce2PlcList', data);
};

// plc厂家型号协议
const PlcBrandModelProtocol = data => {
  return axios.post(baseOriginURL + '/GetPlcList', data);
};

// 新增控制器
const AddControler = data => {
  return axios.post(baseOriginURL + '/AddProduce2Plc', data);
};

// 编辑控制器
const EditControler = data => {
  return axios.put(baseOriginURL + '/UpdateProduce2Plc', data);
};

// 删除控制器
const DeleteControler = data => {
  return axios.put(baseOriginURL + '/DelProduce2Plc', data);
};

// 事件
const Event = data => {
  return axios.post(baseOriginURL + '/GetEventList', data);
};

// 新增事件
const AddEvent = data => {
  return axios.post(baseOriginURL + '/AddEvent', data);
};

// 编辑事件
const EditEvent = data => {
  return axios.put(baseOriginURL + '/UpdateEvent', data);
};

// 删除事件
const DeleteEvent = data => {
  return axios.put(baseOriginURL + '/DelEvent', data);
};

// 事件选择变量
const SelKeyEvent = data => {
  return axios.post(baseOriginURL + '/GetVariableListByEventId', data);
};

// 视频
const Video = data => {
  return axios.post(baseOriginURL + '/GetVideoInfoList', data);
};

// 新增视频
const AddVideo = data => {
  return axios.post(baseOriginURL + '/AddVideoInfo', data);
};

// 编辑视频
const EditVideo = data => {
  return axios.put(baseOriginURL + '/UpdateVideoInfo', data);
};

// 删除视频
const DeleteVideo = data => {
  return axios.put(baseOriginURL + '/DelVideoInfo', data);
};

// 变量
const Key = data => {
  return axios.post(baseOriginURL + '/GetVariableList', data);
};

// 变量名称标识
const KeyNameFlag = data => {
  return axios.post(baseOriginURL + '/GetVariableListByCtrlKey', data);
};

// 新增变量
const AddKey = data => {
  return axios.post(baseOriginURL + '/AddVariable', data);
};

// 编辑变量
const EditKey = data => {
  return axios.put(baseOriginURL + '/UpdateVariable', data);
};

// 删除变量
const DeleteKey = data => {
  return axios.put(baseOriginURL + '/DelVariable', data);
};

// 导入变量
const ImportKey = data => {
  return axios.post(baseOriginURL + '/ImportVariable', data);
};

// 报表
const Report = data => {
  return axios.post(baseOriginURL + '/GetEventReportList', data);
};

// 新增报表
const AddReport = data => {
  return axios.post(baseOriginURL + '/AddEventReport', data);
};

// 编辑报表
const EditReport = data => {
  return axios.put(baseOriginURL + '/UpdateEventReport', data);
};

// 删除报表
const DeleteReport = data => {
  return axios.put(baseOriginURL + '/DelEventReport', data);
};

// 文档
const File = data => {
  return axios.post(baseOriginURL + '/GetDocsList', data);
};

// 新增文档
const AddFile = data => {
  return axios.post(baseOriginURL + '/AddDocs', data);
};

// 编辑文档
const EditFile = data => {
  return axios.put(baseOriginURL + '/UpdateDocs', data);
};

// 删除文档
const DeleteFile = data => {
  return axios.put(baseOriginURL + '/DelDocs', data);
};

// 用户组织
const UserOrgan = params => {
  return axios.get(baseOriginURL2 + '/user/GetUserListByProductId', {
    params
  });
};

// 组态
const Config = params => {
  return axios.get(baseOriginURL3 + '/getScadaList', {
    params
  });
};

// 新增组态
const AddConfig = data => {
  return axios.post(baseOriginURL3 + '/createScada', data);
};

// 编辑组态
const EditConfig = data => {
  return axios.put(baseOriginURL3 + '/updateScada', data);
};

// 复制组态
const CopyConfig = data => {
  return axios.post(baseOriginURL3 + '/copyScada', data);
};

// 删除组态
const DeleteConfig = data => {
  return axios.delete(baseOriginURL3 + '/deleteScada', data);
};

// 变量是否有历史数据
const CheckVariableHistory = data => {
  return axios.post(baseOriginURL + '/CheckVariableHistory', data);
};

export {
  ProductType,
  AddProductType,
  EditProductType,
  DeleteProductType,
  Product,
  ProductInfo,
  AddProduct,
  EditProduct,
  DeleteProduct,
  SyncInfoProduct,
  Controler,
  PlcBrandModelProtocol,
  AddControler,
  EditControler,
  DeleteControler,
  Event,
  AddEvent,
  EditEvent,
  DeleteEvent,
  SelKeyEvent,
  Video,
  AddVideo,
  EditVideo,
  DeleteVideo,
  Key,
  KeyNameFlag,
  AddKey,
  EditKey,
  DeleteKey,
  ImportKey,
  Report,
  AddReport,
  EditReport,
  DeleteReport,
  File,
  AddFile,
  EditFile,
  DeleteFile,
  UserOrgan,
  Config,
  AddConfig,
  EditConfig,
  CopyConfig,
  DeleteConfig,
  CheckVariableHistory
};
